export default __webpack_public_path__ + "static/media/magic-card-back.b0bf4e0e.png";